// 00:00 dan 23:45 gacha 15 daqiqalik variantlar
const TIME_OPTIONS_15: string[] = [];
for (let h = 0; h < 24; h++) {
  for (const m of [0, 15, 30, 45]) {
    TIME_OPTIONS_15.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
  }
}

interface Props {
  value: string | null;
  onChange: (v: string) => void;
  placeholder?: string;
}

export default function TimeSelect({ value, onChange, placeholder = '-- : --' }: Props) {
  return (
    <select
      value={value ?? ''}
      onChange={(e) => {
        if (e.target.value) onChange(e.target.value);
      }}
      style={{
        width: '100%',
        height: 40,
        padding: '0 12px',
        border: '1px solid var(--bl-divider, #e5e7eb)',
        borderRadius: 10,
        fontSize: 14,
        fontWeight: 600,
        color: value ? 'var(--bl-text-strong, #0f172a)' : '#bfbfbf',
        background: 'var(--bl-surface-soft, #f7f8fa)',
        outline: 'none',
        appearance: 'none',
        WebkitAppearance: 'none',
        boxSizing: 'border-box',
        cursor: 'pointer',
        fontVariantNumeric: 'tabular-nums',
        fontFamily: 'inherit',
      }}
    >
      <option value="" disabled>{placeholder}</option>
      {TIME_OPTIONS_15.map((t) => (
        <option key={t} value={t}>{t}</option>
      ))}
    </select>
  );
}
